var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrendingUp = function SvgTrendingUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 8a1 1 0 1 1 0-2h7a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0V9.414l-6.184 6.184a9 9 0 0 1-.511.488 2 2 0 0 1-.687.402 2 2 0 0 1-1.236 0 2 2 0 0 1-.687-.402 9 9 0 0 1-.51-.488l-2.76-2.76a8 8 0 0 0-.415-.4L8 12.43l-.01.009c-.09.076-.205.19-.414.4l-4.869 4.868a1 1 0 0 1-1.414-1.414l4.869-4.869.022-.022a9 9 0 0 1 .512-.488c.174-.148.396-.308.686-.402a2 2 0 0 1 1.236 0c.29.094.512.254.686.402.16.135.333.31.512.488l2.76 2.76c.21.21.325.323.414.4l.01.008.01-.009c.09-.076.205-.19.414-.4L19.586 8z",
    clipRule: "evenodd"
  })));
};
export default SvgTrendingUp;